import { Reducer } from 'react';

import {
    API_FAILURE,
    GlobalAction,
    SET_DATE_TIME_FORMAT,
    SET_IS_ONLINE,
    SET_LOADING,
    SET_OFFLINE_MODE,
    SET_SERVER_TIME_OFFSET,
    USER_LOGIN_API_REQUEST,
    USER_LOGIN_API_SUCCESS,
    USER_LOGOUT_API_REQUEST,
    USER_LOGOUT_API_SUCCESS
} from '../actions';
import { GlobalState } from '../state/initialGlobalState';

export const globalReducers: Reducer<GlobalState, GlobalAction> = (state, action) => {
    if (action.type === SET_LOADING && state.loading !== !!action.payload) {
        return { ...state, loading: !!action.payload };
    }
    if (action.type === USER_LOGIN_API_REQUEST) {
        return { ...state, loading: true, userData: { ...state.userData, status: null } };
    }
    if (action.type === USER_LOGIN_API_SUCCESS) {
        return {
            ...state,
            loading: false,
            userData: { ...state.userData, ...action.payload, status: 'LOGGED_IN' }
        };
    }
    if (action.type === API_FAILURE) {
        return { ...state, loading: false, apiError: action.payload };
    }
    if (action.type === USER_LOGOUT_API_REQUEST) {
        return { ...state, loading: true, userData: { ...state.userData, status: null } };
    }
    if (action.type === USER_LOGOUT_API_SUCCESS) {
        return { ...state, loading: false, userData: { auth: false, status: 'LOGGED_OUT' } };
    }
    if (action.type === SET_DATE_TIME_FORMAT) {
        return { ...state, dateFormat: action.payload.dateFormat, timeFormat: action.payload.timeFormat, dateTimeFormatLoaded: true };
    }
    if (action.type === SET_IS_ONLINE) {
        return { ...state, isOnline: action.payload };
    }
    if (action.type === SET_OFFLINE_MODE) {
        return { ...state, offlineMode: action.payload };
    }
    if (action.type === SET_SERVER_TIME_OFFSET) {
        return { ...state, serverTimeOffset: action.payload };
    }

    return state;
};
